import "@babylonjs/loaders/glTF";
import { ArcRotateCamera, Color4, DirectionalLight, Engine, HemisphericLight, Scene, SceneLoader, TransformNode, Vector3 } from "@babylonjs/core";

const previewCache = new Map<string, Promise<string>>();

export function getInventoryModelPreview(modelPath:string):Promise<string>{
  const cached=previewCache.get(modelPath);if(cached)return cached;
  const rendered=renderInventoryModelPreview(modelPath);previewCache.set(modelPath,rendered);return rendered;
}

export function hydrateInventoryModelPreviews(root:ParentNode):void{
  root.querySelectorAll<HTMLImageElement>("img[data-model-preview]").forEach((image)=>{
    const path=image.dataset.modelPreview;if(!path||image.dataset.previewReady==="true")return;
    image.dataset.previewReady="loading";
    void getInventoryModelPreview(path).then((source)=>{if(image.isConnected&&image.dataset.modelPreview===path){image.src=source;image.dataset.previewReady="true";}}).catch(()=>{if(image.isConnected)image.dataset.previewReady="fallback";});
  });
}

async function renderInventoryModelPreview(modelPath:string):Promise<string>{
  const canvas=document.createElement("canvas");canvas.width=256;canvas.height=256;
  const engine=new Engine(canvas,true,{preserveDrawingBuffer:true,stencil:true,alpha:true},true);
  const scene=new Scene(engine);scene.clearColor=new Color4(0,0,0,0);
  const camera=new ArcRotateCamera("inventory-preview-camera",-Math.PI*.72,Math.PI*.42,3,Vector3.Zero(),scene);camera.fov=.56;
  const ambient=new HemisphericLight("inventory-preview-fill",new Vector3(.2,1,.25),scene);ambient.intensity=1.35;
  const key=new DirectionalLight("inventory-preview-key",new Vector3(-.7,-1,.5),scene);key.intensity=1.8;
  const slash=modelPath.lastIndexOf("/");
  try{
    const imported=await SceneLoader.ImportMeshAsync(null,modelPath.slice(0,slash+1),modelPath.slice(slash+1),scene);
    const displayRoot=new TransformNode("inventory-preview-root",scene);
    for(const mesh of imported.meshes)if(!mesh.parent)mesh.parent=displayRoot;
    await scene.whenReadyAsync();scene.render();
    let minimum=new Vector3(Number.POSITIVE_INFINITY,Number.POSITIVE_INFINITY,Number.POSITIVE_INFINITY),maximum=new Vector3(Number.NEGATIVE_INFINITY,Number.NEGATIVE_INFINITY,Number.NEGATIVE_INFINITY);
    const geometryMeshes=imported.meshes.filter((mesh)=>mesh.getTotalVertices()>0);
    if(geometryMeshes.length===0)throw new Error(`Tiada geometri pratonton: ${modelPath}`);
    for(const mesh of geometryMeshes){mesh.computeWorldMatrix(true);const bounds=mesh.getBoundingInfo().boundingBox;minimum=Vector3.Minimize(minimum,bounds.minimumWorld);maximum=Vector3.Maximize(maximum,bounds.maximumWorld);}
    const size=maximum.subtract(minimum),extent=Math.max(size.x,size.y,size.z,.001);displayRoot.scaling.setAll(1.7/extent);
    const center=minimum.add(maximum).scale(.5);displayRoot.position.copyFrom(center.scale(-1.7/extent));
    await scene.whenReadyAsync();scene.render();await new Promise<void>((resolve)=>requestAnimationFrame(()=>resolve()));scene.render();
    return canvas.toDataURL("image/png");
  }finally{scene.dispose();engine.dispose();}
}
